define('apps/check-requirements/views/requirement-container-view',[
    'app',
    'common/components/nunjucks-config/main',
    'njs!apps/check-requirements/templates/includes/_requirement_container_view',
    'i18next',
    'common/components/vue-wrapper/helpers/mount-vue-component',
    '@discoveryedu/nebula-components'
], function(app, nunjucksConfig, template, i18next, mountVueComponent, NebulaComponents) {
    "use strict";

return Marionette.ItemView.extend({

        "template": template,

        "initialize": function () {

            var locale = app.initData.get('locale');
            if (locale !== 'en') {
                var jsonUrl;

                jsonUrl = app.get_path('edde_static', 'common/components/nunjucks-config/localization/' + locale.toLowerCase() + '.json');

                $.getJSON(jsonUrl, _.bind(function(messages) {
                    nunjucksConfig.init(_.bind(this.render, this), messages, locale);
                }, this));
            } else {
                nunjucksConfig.init(_.bind(this.render, this));
            }

        },

        "onRender": function() {
            mountVueComponent(
                NebulaComponents.NebulaProductBar,
                '.nebula-product-bar-wrapper',
                {
                    "homeLogoElement": "div",
                    "pageTitle": i18next.t('Check Your System'),
                    "prelogin": true
                }
            );
        }
    });
});

